import React from 'react'
import './Home.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'

export const Home = () => {
  return (
    <div className='home-wrapper'>
        <p className='text-center'><span><FontAwesomeIcon icon={faTriangleExclamation} /></span><br/>Select repository from side menu</p>
    </div>
  )
}
